import { useEffect } from 'react';
import { getSEO } from './seoData';

// Updates document.title, meta description, canonical link and Open Graph /
// Twitter tags to match the current page. index.html still ships good
// defaults for the home page (and for crawlers that don't execute JS), and
// this hook keeps every other route's <head> accurate for JS-rendering
// crawlers, social share previews taken after render, and the browser tab.
function setMeta(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export default function useSEO(route) {
  useEffect(() => {
    const seo = getSEO(route);

    document.title = seo.title;

    setMeta('meta[name="description"]', 'content', seo.description);
    setMeta('link[rel="canonical"]', 'href', seo.url);

    setMeta('meta[property="og:title"]', 'content', seo.title);
    setMeta('meta[property="og:description"]', 'content', seo.description);
    setMeta('meta[property="og:url"]', 'content', seo.url);
    setMeta('meta[property="og:image"]', 'content', seo.image);

    setMeta('meta[name="twitter:title"]', 'content', seo.title);
    setMeta('meta[name="twitter:description"]', 'content', seo.description);
    setMeta('meta[name="twitter:image"]', 'content', seo.image);
  }, [route]);
}
